import axios from 'axios'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'


const baseUrl = process.env.VUE_APP_BASE_API
export function downLoadExcel(str,param, filename) {
  var url = baseUrl  +"/"+ str
  axios({
    method: 'post',
    url: url,
    data: param,
    responseType: 'blob',
    headers: { 'Authorization': 'Bearer ' + storage.get(ACCESS_TOKEN) }
  }).then(res => {
    resolveBlob(res, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8')
  })
}
/**
 * 解析blob响应内容并下载
 * @param {*} res blob响应内容
 * @param {String} mimeType MIME类型
 */
export function resolveBlob (res, mimeType) {
  const aLink = document.createElement('a')
  var blob = new Blob([res.data], { type: mimeType })
  // //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
  var patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
  console.log("headers",res.headers)
  var contentDisposition = decodeURI(res.headers['content-disposition'])
  var result = patt.exec(contentDisposition)
  var fileName = result[1]
  fileName = fileName.replace(/"/g, '')
  aLink.style.display = 'none'
  aLink.href = URL.createObjectURL(blob)
  aLink.setAttribute('download', fileName) // 设置下载文件名称
  document.body.appendChild(aLink)
  aLink.click()
  URL.revokeObjectURL(aLink.href) // 清除引用
  document.body.appendChild(aLink)
}
